/*
 * @version: V1.0.0
 * @Date: 2023-11-02 18:00:37
 * @LastEditors: lzq
 * @LastEditTime: 2023-12-25 16:32:59
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\api\invertory\index.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 查询报废列表
export function getCancelPage(params) {
  return request({
    url: '/system/cancel/list',
    method: 'get',
    params
  })
}

export function getCancelCodePage(params) {
  return request({
    url: '/system/cancelCode/list',
    method: 'get',
    params
  })
}
